import { Actions } from './actions.js';
const actionProps = {
    onNavigationNext: Actions.NAVIGATION_NEXT,
    onNavigationPrev: Actions.NAVIGATION_PREV,
    onItemClick: Actions.ITEM_CLICKED,
};
export default actionProps;
